import { render, staticRenderFns } from "./Fence.vue?vue&type=template&id=0a30cf3f&scoped=true"
import script from "./Fence.vue?vue&type=script&lang=ts"
export * from "./Fence.vue?vue&type=script&lang=ts"
import style0 from "./Fence.vue?vue&type=style&index=0&id=0a30cf3f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a30cf3f",
  null
  
)

export default component.exports